import userConstants from '../actiontypes/user';

const initialState = {
  email: ''
};

function user(state = initialState, action) {
  switch (action.type) {
    case userConstants.PERSONAL_DETAIL_REQUEST:
      return { ...state };
    case userConstants.PERSONAL_DETAIL_SUCCESS:
      return { ...state, email: action.payload.email, primerNombre: action.payload.primerNombre, apellidoPaterno: action.payload.apellidoPaterno, genero: action.payload.genero  };
    case userConstants.PERSONAL_DETAIL_FAILURE:
      return { ...state, email: '' };
    case userConstants.EMAIL_CHANGED:
      return { ...state, email: action.payload };
    default:
      return state;
  }
}

export default user;
